import { FleetConfiguration } from './model/fleet-configuration';
import { NetworkProfile } from './model/network-profile';
import { StaticRoute } from './model/static-route';
import { IPPool } from './model/ip-pool';
import { IPAM } from './model/ipam';
import { NETWORK_TYPES } from './constants';
let _ = require('lodash');
export class Util {

    public static isResourceConfigCompleted(fleetConfig: FleetConfiguration) {
        return ( fleetConfig.vcenterInstanceId !== "" && fleetConfig.resourcePoolId !== "" && fleetConfig.dataStoreId !== "" );
    }

    public static isNetworkConfigCompleted() {

    }

    public static getEmptyNetworkProfiles(){
        let networkProfile: NetworkProfile = new NetworkProfile();
        networkProfile.networkId = '';
        networkProfile.networkType = "DistributedVirtualPortgroup";
        networkProfile.networkName = '';
        networkProfile.tags = []
        networkProfile.ipPool = new IPPool();
        networkProfile.ipPool.provider = 'HCX';
        networkProfile.transitPool = new IPPool();
        networkProfile.isItNewlyAdded = true;
        return networkProfile;
    }

    public static getEmptyStaticRoute(){
        return new StaticRoute();
    }

    public static isNetworkLANFacing(networkProfile: NetworkProfile){
        let lanFacing: boolean = false;
        for(let i:number=0;i<networkProfile.tags.length;++i){
            if(networkProfile.tags[i] === NETWORK_TYPES.VMOTION || networkProfile.tags[i] === NETWORK_TYPES.MANAGEMENT){
                return true;
            }
        }
        return lanFacing;
    }

    public static convertToSchema(fleetConfig:FleetConfiguration, siteId:string){
        let configSchema: any = {};
        configSchema.siteId = siteId;
        configSchema.resourceId = fleetConfig.vcenterInstanceId;
        configSchema.vcenter_instanceId = fleetConfig.vcenterInstanceId;
        configSchema.datastore = fleetConfig.dataStoreId;
        configSchema.compute = fleetConfig.resourcePoolId;
        configSchema.computeClusterId = fleetConfig.clusterId;
        configSchema.name = fleetConfig.name;
        configSchema.networks = {};
        configSchema.staticRoutes = [];
        for(let networkProfile of fleetConfig.networkProfiles){
            let tags = networkProfile.tags;
            let networkSchemaObject = this.convertNetworkProfileToSchemaObject(networkProfile);
            for(let tag of tags){
                switch(tag){
                    case NETWORK_TYPES.MANAGEMENT:
                        configSchema.networks.mgmtNetwork = networkSchemaObject;
                        break;
                    case NETWORK_TYPES.VMOTION:
                        configSchema.networks.vmotionNetwork = networkSchemaObject;
                        break;
                    case NETWORK_TYPES.INTERNET:
                        configSchema.networks.externalNetwork = networkSchemaObject;
                        break;
                    case NETWORK_TYPES.DC1:
                        configSchema.networks.directConnectNetwork1 = networkSchemaObject;
                        break;
                    case NETWORK_TYPES.DC2:
                        configSchema.networks.directConnectNetwork2 = networkSchemaObject;
                        break;
                    default:
                        break;
                }
            }
        }
        for( let staticRoute of fleetConfig.staticRoutes){
            configSchema.staticRoutes.push(this.convertStaticRouteToSchemaObject(staticRoute));
        }

        return JSON.stringify(configSchema);
    }

    private static convertNetworkProfileToSchemaObject(networkProfile:NetworkProfile){
        let networkSchema: any = {};
        networkSchema.id = networkProfile.networkId;
        networkSchema.networkName = networkProfile.networkName;
        networkSchema.networkType = networkProfile.networkType;
        networkSchema.ipPool = this.convertIPPoolToSchemaObject(networkProfile.ipPool);
        if(networkProfile.transitPool.provider !== ''){
            networkSchema.transitPool = this.convertIPPoolToSchemaObject(networkProfile.transitPool);
        }
        return networkSchema; 
    }

    private static convertStaticRouteToSchemaObject(staticRoute:StaticRoute){
        let staticRouteSchema: any = {};
        staticRouteSchema.network = staticRoute.network;
        staticRouteSchema.gateway = staticRoute.gateway;
        if(staticRoute.mtu){
            staticRouteSchema.mtu = staticRoute.mtu.toString();
        }
        return staticRouteSchema;
    }

    private static convertIPPoolToSchemaObject(ipPool:IPPool){
        let ipPoolSchema:any = {}
        ipPoolSchema.provider = ipPool.provider;
        if(ipPool.provider === 'NSX'){
            ipPoolSchema.poolId = ipPool.ipPoolId;
        } else {
            ipPoolSchema.range = ipPool.ipAddresses.split(",");
            ipPoolSchema.prefixLength = ipPool.prefixLength.toString();
            if(ipPool.defaultGateway){
                ipPoolSchema.gateway = ipPool.defaultGateway;
            }
        }
        return ipPoolSchema;
    }

    public static convertToFleetConfig(fleetConfigSchemaObject){
        let fleetConfig:FleetConfiguration = new FleetConfiguration();
        fleetConfig.id = fleetConfigSchemaObject.resourceId;
        fleetConfig.vcenterInstanceId = fleetConfigSchemaObject.vcenter_instanceId;
        fleetConfig.vcenterName = fleetConfigSchemaObject.vcenter_instanceName;
        fleetConfig.dataStoreId = fleetConfigSchemaObject.datastore;
        fleetConfig.dataStoreName = fleetConfigSchemaObject.datastoreName;
        fleetConfig.resourcePoolId = fleetConfigSchemaObject.compute;
        fleetConfig.clusterId = fleetConfigSchemaObject.computeClusterId;
        fleetConfig.resourcePoolName = fleetConfigSchemaObject.computeName;
        fleetConfig.networkProfiles = new Array<NetworkProfile>();
        fleetConfig.staticRoutes = new Array<StaticRoute>();
        if(fleetConfigSchemaObject.networks.hasOwnProperty("mgmtNetwork")){
            let networkProfile:NetworkProfile = this.convertToNetworkProfile(fleetConfigSchemaObject.networks.mgmtNetwork,[NETWORK_TYPES.MANAGEMENT]);
            fleetConfig.networkProfiles.push(networkProfile);
        }

        if(fleetConfigSchemaObject.networks.hasOwnProperty("vmotionNetwork")){
            let success = this.findInNProfilesAndAddTag(fleetConfig,fleetConfigSchemaObject.networks.vmotionNetwork,NETWORK_TYPES.VMOTION)
            if(!success){
                let networkProfile:NetworkProfile = this.convertToNetworkProfile(fleetConfigSchemaObject.networks.vmotionNetwork,[NETWORK_TYPES.VMOTION]);
                fleetConfig.networkProfiles.push(networkProfile);
            }
        }

        if(fleetConfigSchemaObject.networks.hasOwnProperty("externalNetwork")){
            let networkProfile:NetworkProfile = this.convertToNetworkProfile(fleetConfigSchemaObject.networks.externalNetwork,[NETWORK_TYPES.INTERNET]);
            fleetConfig.networkProfiles.push(networkProfile);
        }

        if(fleetConfigSchemaObject.networks.hasOwnProperty("directConnectNetwork1")){
            let networkProfile:NetworkProfile = this.convertToNetworkProfile(fleetConfigSchemaObject.networks.directConnectNetwork1,[NETWORK_TYPES.DC1]);
            fleetConfig.networkProfiles.push(networkProfile);
        }

        if(fleetConfigSchemaObject.networks.hasOwnProperty("directConnectNetwork2")){
            let networkProfile:NetworkProfile = this.convertToNetworkProfile(fleetConfigSchemaObject.networks.directConnectNetwork2,[NETWORK_TYPES.DC2]);
            fleetConfig.networkProfiles.push(networkProfile);
        }
        if(fleetConfigSchemaObject.hasOwnProperty("staticRoutes")){
            for( let i =0; i<fleetConfigSchemaObject.staticRoutes.length;++i){
                fleetConfig.staticRoutes.push(this.convertToStaticRoute(fleetConfigSchemaObject.staticRoutes[i]))
            }
        }
        fleetConfig.name = fleetConfigSchemaObject.name;

        // add service mesh transformation status
        fleetConfig.smEnabledMessage = fleetConfigSchemaObject.smEnabledMessage;
        fleetConfig.smEnabledStatus = fleetConfigSchemaObject.smEnabledStatus;

        // Truncate string
        fleetConfig.displayVcenterName = this.createToolTip(fleetConfig.vcenterName, 30);

        fleetConfig.displayResourcePoolName = this.createToolTip((fleetConfig.resourcePoolName === '') ? fleetConfig.resourcePoolId :  fleetConfig.resourcePoolName);

        fleetConfig.displayDataStoreName = this.createToolTip((fleetConfig.dataStoreName === '') ? fleetConfig.dataStoreId :  fleetConfig.dataStoreName);
        
        return fleetConfig;
    }

    private static findInNProfilesAndAddTag(fleetConfig, networkSchemaObject, tag){
        for(let networkProfile of fleetConfig.networkProfiles )
        {
            if(networkProfile.networkId === networkSchemaObject.id){
                networkProfile.tags.push(tag);
                return true;
            }
        }
        return false;
    }

    private static convertToNetworkProfile(networkSchemaObject, tags){
        let networkProfile:NetworkProfile = new NetworkProfile();
        networkProfile.networkId = networkSchemaObject.id;
        networkProfile.networkName = networkSchemaObject.networkName;
        networkProfile.networkType = networkSchemaObject.networkType;
        networkProfile.tags = tags;
        networkProfile.ipPool = this.convertToIPPool(networkSchemaObject.ipPool);
        if(networkSchemaObject.hasOwnProperty('transitPool')){
            networkProfile.transitPool = this.convertToIPPool(networkSchemaObject.transitPool);
        } else {
            networkProfile.ipPool.provider = 'HCX';
            networkProfile.transitPool = new IPPool();
        }
        
        return networkProfile;
    }

    private static convertToStaticRoute(staticRouteSchema){
        let staticRoute:StaticRoute = new StaticRoute();
        staticRoute.network = staticRouteSchema.network;
        staticRoute.gateway = staticRouteSchema.gateway;
        staticRoute.mtu = staticRouteSchema.mtu;

        return staticRoute;
    }

    private static convertToIPPool(ipPoolSchema){
        let ipPool:IPPool = new IPPool();
        ipPool.provider = ipPoolSchema.provider;
        if(ipPoolSchema.range){
            ipPool.ipAddresses = ipPoolSchema.range.join();
        } else {
            ipPool.ipAddresses = "";
        }
        ipPool.prefixLength = ipPoolSchema.prefixLength;
        if(ipPoolSchema.gateway){
            ipPool.defaultGateway = ipPoolSchema.gateway;
        } else {
            ipPool.defaultGateway = "";
        }
        ipPool.ipPoolId = ipPoolSchema.poolId;
        return ipPool;
    }

    public static validateNetworkProfiles(networkProfiles:Array<NetworkProfile>) {
        let allTags:any[] = [];
        let validateObject: any = {};
        for( let networkProfile of networkProfiles){
            allTags = allTags.concat(networkProfile.tags);
        }
        let lanFacingTags:any[] = _.intersection(allTags,[NETWORK_TYPES.MANAGEMENT,NETWORK_TYPES.VMOTION]);
        let wanFacingTags: any[] = _.intersection(allTags,[NETWORK_TYPES.INTERNET,NETWORK_TYPES.DC1,NETWORK_TYPES.DC2]);
        if(lanFacingTags.length === 0 || wanFacingTags.length === 0){
            validateObject.error = true;
            validateObject.errorMessage = "Please select at least one LAN facing and WAN facing network";
        } else {
            validateObject.error = false;
            validateObject.errorMessage = "";
        }
        return validateObject;
    }

    public static getErrorMessage(error){
        let errorMessage: string = '';
        let errorBody = error._body ? JSON.parse(error._body) : '';
        if (errorBody && errorBody.message) {
            errorMessage = error.message;
        } else if(errorBody && errorBody.hasOwnProperty("errors")) {
            for(let error of errorBody.errors){
              errorMessage += error.message + "\n"
            }
        }
        return errorMessage;
      }
    
    public static createToolTip(string, maxLength = 20) {
        if (string.length < maxLength) {
            return string;
        }
        let strToDisplay = string.substring(0, maxLength - 3) + '...'
        let str = '<span role="tooltip" aria-haspopup="true" class="tooltip tooltip-md no-link">' +
                strToDisplay +
                '<span class="tooltip-content">'+ string + '</span>' +
                '</span>';
        return str;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/utils.ts